import React from "react";
import Container from "react-bootstrap/Container";
import useGoTo from "../../hooks/useGoTo";
import Loading from "../../components/Loading";
import TotemResult from "./TotemResult";

export default function SelfCheckoutTableStatus({ shortReference, order }) {
  const goto = useGoTo();
  const [seconds, setSeconds] = React.useState(30);
  const jaVoltou = React.useRef(false);

  React.useEffect(() => {
    const id = setInterval(() => setSeconds((v) => v - 1), 1000);
    return () => clearInterval(id);
  }, []);

  // Antes isto rodava no corpo do render (`if (seconds <= 0) handleNovoPedido()`),
  // ou seja, um history.replace durante a renderização — e repetindo a cada
  // tick depois do zero. O ref garante que dispare uma vez só.
  React.useEffect(() => {
    if (seconds > 0 || jaVoltou.current) return;
    jaVoltou.current = true;
    goto("/");
  }, [seconds, goto]);

  if (!order) {
    return (
      <Container>
        <Loading message="Carregando Status Autoatendimento Tablet na Mesa..." />
      </Container>
    );
  }

  const handleNovoPedido = () => {
    goto("/");
  };

  return (
    <TotemResult
      tone="success"
      title="Pedido enviado!"
      message="Vamos começar o preparo agora mesmo. Para mudar o pedido ou pagar a conta, chame um atendente."
      orderNumber={shortReference}
      actions={
        <button
          type="button"
          className="btn btn-shop totem-btn totem-btn--primary"
          onClick={handleNovoPedido}
        >
          Novo pedido ({seconds})
        </button>
      }
    />
  );
}
